import { useContext } from "react";
import { BundleTypes } from "../constants";
import { Button, Divider } from "@shopify/polaris";
import styles from "./Bxgy.module.css";
import { BxgyBundleContext } from "./Bxgy";
import GeneralSettings from "../CommonFields/GeneralSettings";
import BundleTypeSettings from "../CommonFields/BundleTypeSettings";
import BundleSpecificSettings from "../CommonFields/BundleSpecificSettings";
import { BxgyConfigInterface } from "../Types";

const BxgySettingsForm = () => {
    const context = useContext(BxgyBundleContext);
    if (!context) return;
    const {
        fields: {
            general_settings: { show_bundle_on_product_page, show_multiple_bundles_on_product_page },
            bundles_settings: {
                enable_stock_control,
                out_of_stock_text,

                work_only_with_widget,
                bundle_position,
            },
            show_bundle_widget,
            free_shipping,
        },
        handleNext,
        dispatchBundleConfig,
        bundleConfig,
        submit,
    } = context;

    return (
        <div className={styles.formWrapper}>
            <div style={{ marginBottom: "4px" }}>
                <Divider borderColor="border" />
            </div>

            <div className={styles.collapsibleFormBox}>
                <GeneralSettings
                    bundleConfig={bundleConfig as BxgyConfigInterface}
                    dispatchBundleConfig={dispatchBundleConfig}
                    show_bundle_on_product_page={show_bundle_on_product_page}
                    show_multiple_bundles_on_product_page={show_multiple_bundles_on_product_page}
                />
                <div className={styles.dividerStyle}>
                    <Divider borderColor="border" />
                </div>
                <BundleTypeSettings
                    bundleName={BundleTypes.BXGY}
                    bundleConfig={bundleConfig as BxgyConfigInterface}
                    dispatchBundleConfig={dispatchBundleConfig}
                    submit={submit}
                    enable_stock_control={enable_stock_control}
                    out_of_stock_text={out_of_stock_text}
                    work_only_with_widget={work_only_with_widget}
                    bundle_position={bundle_position}
                />
                <div className={styles.dividerStyle}>
                    <Divider borderColor="border" />
                </div>
                <BundleSpecificSettings
                    dispatchBundleConfig={dispatchBundleConfig}
                    show_bundle_widget={show_bundle_widget}
                    free_shipping={free_shipping}
                />
            </div>

            <div className={styles.dividerStyle}>
                <Divider borderColor="border" />
            </div>

            <div className={styles.bottomRowCta}>
                <Button onClick={() => handleNext(2, "Target")}>Back</Button>
                <span></span>
            </div>
        </div>
    );
};

export default BxgySettingsForm;
